var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnect3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    height: 100,
    viewBox: "0 0 288 100",
    width: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(29.8 0 0 -17.2 23553.1 9735.3)",
    gradientUnits: "userSpaceOnUse",
    id: "a",
    x1: -787.4,
    x2: -786.9,
    y1: 562.2,
    y2: 562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c20000",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c20000",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c20000",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c20000",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(29.8 0 0 -17.2 23539.8 9733.8)",
    gradientUnits: "userSpaceOnUse",
    id: "b",
    x1: -787,
    x2: -787.3,
    y1: 562.3,
    y2: 562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c20000",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c20000",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c20000",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c20000",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(14.9 0 0 -34.5 11386.5 19925.4)",
    gradientUnits: "userSpaceOnUse",
    id: "c",
    x1: -760,
    x2: -759.7,
    y1: 576.5,
    y2: 576.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c20000",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c20000",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c20000",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c20000",
    stopOpacity: 0.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Natwest Secondary Horizontal RGB NEG"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M191.2,43.6v5h-6.1v13c0,2.3,1.1,2.8,3.1,2.8s2.1-.2,2.5-.4h.5c0-.1,0,4.9,0,4.9h-.3c-1.7.5-3.1.6-5.2.6s-6.2-.5-6.2-6.7v-14.2h-3.6v-.3c0-.2,0-2,0-3.6v-1.1h3.6v-6.4l5.6-2v8.4h6.1ZM228.9,35.4l-6.7,33.5h-5.7l-5.9-23.3-6,23.3h-5.6l-7-33.5h5.9l4.6,22.7,5.7-22.7h5.5c.5,2.1,5.7,22.4,5.7,22.7,0-.3,4-22,4.2-22.7h5.6ZM234.7,53.6c.1-2.4,1.8-5.5,5.4-5.5s5.1,3.4,5.2,5.5h-10.6ZM240.4,43.1c-4.3,0-11.5,2.8-11.5,13.2s9.9,13.1,11.9,13.1c4.2,0,6.1-.9,7.9-1.7h.2v-5.4l-.5.3c-1.3.8-3.9,1.8-6.8,1.8-5.9,0-6.7-4.2-6.8-6h16.2v-.3c.5-3.5,0-8.4-2.8-11.7-1.9-2.2-4.5-3.3-7.7-3.3M271.7,61.9c0,3.8-3.3,7.6-9.6,7.6s-5.8-.7-8-1.7h-.2v-5.5l.5.3c1.8,1,4.7,2,7.5,2s4-.9,4-2.5-.9-2-3.1-2.9l-.9-.4c-1.1-.5-2-.9-3.5-1.6-1.5-.7-4.9-2.2-4.9-6.8s1.9-7.2,9.1-7.2,5.9.8,7,1.4h.2v5.4l-.5-.2c-2.3-1.1-4.3-1.7-6.5-1.7s-3.5.2-3.5,2.1,1.7,2.2,3.1,2.8h.3c1,.6,1.8.9,2.4,1.2l.7.3c4.3,1.9,5.9,3.9,5.9,7.5M144.9,35.4h5.5v33.5h-5.3l-14.6-23.3v23.3h-5.5v-33.5h5.5l14.5,23.5v-23.5h0ZM281.4,48.6v13c0,2.3,1.1,2.8,3.1,2.8s2-.2,2.5-.3l.5-.2v5h-.3c-1.7.5-3.1.6-5.2.6s-6.2-.5-6.2-6.7v-14.2h-3.6v-.3c0-.2,0-2,0-3.6v-1.1h3.6v-6.4l5.6-2v8.4h6.1v5h-6.1ZM168.8,61.5c-.6.8-2.7,2.9-5.8,2.9s-4-1.4-4-3.5,1.8-3.5,4.8-3.5h4.9v4.1h0ZM164.4,43.1c-2.8,0-5.6.5-7.6,1.3h-.2v5.2l.5-.3c1.3-.6,4.5-1.2,6.4-1.2,4.9,0,5.1,1.9,5.2,4.3h-5.3c-7,0-10.1,4.4-10.1,8.4s4.5,8.6,8.9,8.6,4.9-1.1,6.5-2.5v2h5.6v-17.1c0-7.9-6.9-8.8-9.9-8.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100,50c0,46.4-3.6,50-50,50S0,96.4,0,50,3.6,0,50,0s50,3.6,50,50Z",
    fill: "#3c1053"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.9 61L45 61 55 78.2 74.9 78.2 74.9 78.2 74.9 78.2 64.9 61z",
    "data-name": "Path",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9 43.8L84.8 61 74.9 78.2 64.9 61 74.9 43.8z",
    "data-name": "Path",
    fill: "#c20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 17.9L60 17.9 40.1 17.9 30.1 35.1 50 35.1 50 35.1 60 17.9z",
    "data-name": "Path",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35.1L60 52.4 69.9 35.1 60 17.9 50 35.1z",
    "data-name": "Path",
    fill: "#c20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1 61L35.1 61 45 43.8 25.1 43.8 15.2 61 15.2 61 15.2 61 35.1 61z",
    "data-name": "Path",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 78.2L45 78.2 25.1 78.2 15.2 61 15.2 61 35.1 61 45 78.2z",
    "data-name": "Path",
    fill: "#c20000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.9 43.8L60 52.4 50 52.4 50 52.4 45 61 64.9 61 74.9 43.8 64.9 43.8z",
    "data-name": "Path",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1 43.8L45 43.8 50 52.4 50 52.4 60 52.4 50 35.1 30.1 35.1 35.1 43.8z",
    "data-name": "Path",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 69.6L45 61 50 52.4 50 52.4 45 43.8 35.1 61 45 78.2 50 69.6z",
    "data-name": "Path",
    fill: "url(#c)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect3);
export default __webpack_public_path__ + "static/media/connect3.98ce6fcaa154038083cc02f8442d89c3.svg";
export { ForwardRef as ReactComponent };